import { parseISO, isValid, startOfDay, isEqual } from 'date-fns';
export function formatValue(valueToFormat, format) {
    var formattedValue = '';
    var maskChar = '_';
    // replace letters (a-z) for maskChar, e.g. DD/MM/YYYY -> __/__/____
    var maskFromFormat = format.replace(/[a-z]/gi, maskChar);
    // remove every non-digit value from value (e.g. "01012021")
    var parsedValue = valueToFormat.replace(/\D+/gi, '');
    if (parsedValue === '') {
        return parsedValue;
    }
    for (
    // two variables to iterate mask (e.g. "__/__/____") and parsedValue (e.g. "01012021")
    var maskIndex = 0, parsedValueIndex = 0; 
    // run it for each char in the mask
    maskIndex < maskFromFormat.length; 
    // always go to next mask char
    maskIndex++) {
        // if the char in the mask is equal to maskChar ("_") && still have parsedValue to append
        // in this case, it is true for positions, 0,1,3,4,6,7,8,9
        if (maskFromFormat[maskIndex] === maskChar &&
            parsedValueIndex < parsedValue.length) {
            // Append the current char from parsedValue to formattedValue
            formattedValue += parsedValue[parsedValueIndex]; // 0, 01, 01/0, 01/01, 01/01/2...
            parsedValueIndex++;
        }
        else {
            // Append the current char from maskFromFormat to formattedValue
            formattedValue += maskFromFormat[maskIndex]; // 01/, 01/01/
        }
    }
    return formattedValue;
}
export var _DATE_PICKER_DEFAULT_FORMAT = 'yyyy-MM-dd';
export function getFormat(format, locale) {
    var _a;
    var _format = format || ((_a = locale === null || locale === void 0 ? void 0 : locale.formatLong) === null || _a === void 0 ? void 0 : _a.date({ width: 'short' }));
    if (_format) {
        /* ensuring correct date-fns format to support DD/MM/YYYY for example.
         * https://date-fns.org/v2.21.1/docs/format */
        return (_format
            .replace(/dd/i, 'dd')
            .replace(/mm/i, 'MM')
            /* date-fns locale format gives not only 'yyyy' as year, but dependent on the locale also 'y' for example.
             * We make it always 'yyyy'. */
            .replace(/y+/i, 'yyyy'));
    }
    return _DATE_PICKER_DEFAULT_FORMAT;
}
export function getMaxDate(maxDate, disableFuture) {
    if (disableFuture && maxDate) {
        // eslint-disable-next-line no-console
        console.warn('[DatePicker] `disableFuture` has preference over `maxDate`, so the `maxDate` value will be ignored');
    }
    return disableFuture
        ? startOfDay(new Date())
        : getStartOfDayByValue(maxDate, 'maxDate') || parseISO('2100-01-01');
}
export function getMinDate(minDate, disablePast) {
    if (disablePast && minDate) {
        // eslint-disable-next-line no-console
        console.warn('[DatePicker] `disablePast` has preference over `minDate`, so the `minDate` value will be ignored');
    }
    return disablePast
        ? startOfDay(new Date())
        : getStartOfDayByValue(minDate, 'minDate') || parseISO('1900-01-01');
}
export function getStartOfDayByValue(value, propertyName) {
    var date = null;
    // if empty string or null, just return null, both are valid values
    if (!value) {
        return null;
    }
    if (typeof value === 'string') {
        date = parseISO(value);
        // if the parsed date by the string is an invalid date, show a message on the console
        if (!isValid(date)) {
            logParseValueError(value, propertyName);
        }
    }
    else {
        date = value;
    }
    // if the parsed string or the received date is valid, then set the time to zero
    if (date && isValid(date)) {
        // checks if the local timezone times are both zero
        if (!isEqual(date, startOfDay(date))) {
            logParseValueError(date, propertyName);
        }
        date = startOfDay(date);
    }
    return date;
}
function logParseValueError(value, propertyName) {
    // eslint-disable-next-line no-console
    console.error("[DatePicker] The given value [" + value.toString() + "]" + (propertyName ? " for [" + propertyName + "]" : '') + " should be in a local timezone with 00:00:00 time to properly compare dates. For example a \"2020-12-31\", \"2020-12-31T00:00:00+02:00\". UTC ISO string (\"2020-12-31T00:00:00.000Z\") should not be used, because that is not properly comparable against a local date.");
}
//# sourceMappingURL=utils.js.map